var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 26,
    viewBox: "0 0 49 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 4C0.75 1.79086 2.54086 0 4.75 0H44.75C46.9591 0 48.75 1.79086 48.75 4V22C48.75 24.2091 46.9591 26 44.75 26H4.75C2.54086 26 0.75 24.2091 0.75 22V4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8217 6.5C27.9728 6.5 25.427 7.97662 25.427 10.7048C25.427 13.8335 29.9422 14.0495 29.9422 15.6213C29.9422 16.2831 29.1837 16.8755 27.8884 16.8755C26.05 16.8755 24.676 16.0477 24.676 16.0477L24.0881 18.8008C24.0881 18.8008 25.6709 19.5 27.7724 19.5C30.8871 19.5 33.338 17.9508 33.338 15.1761C33.338 11.8701 28.804 11.6604 28.804 10.2015C28.804 9.68305 29.4266 9.11503 30.7182 9.11503C32.1756 9.11503 33.3646 9.71707 33.3646 9.71707L33.94 7.05814C33.94 7.05814 32.6463 6.5 30.8217 6.5ZM4.75748 6.70069L4.68848 7.10204C4.68848 7.10204 5.88701 7.32137 6.96646 7.75894C8.35633 8.26065 8.45537 8.55275 8.68944 9.45995L11.2402 19.293H14.6595L19.9273 6.70069H16.5158L13.1309 15.2623L11.7498 8.00505C11.6231 7.17449 10.9814 6.70069 10.1961 6.70069H4.75748ZM21.2991 6.70069L18.6229 19.293H21.876L24.5428 6.70065H21.2991V6.70069ZM39.4429 6.70069C38.6584 6.70069 38.2428 7.12067 37.9378 7.85457L33.1718 19.293H36.5833L37.2433 17.3866H41.3995L41.8008 19.293H44.811L42.1849 6.70069H39.4429ZM39.8866 10.1027L40.8978 14.828H38.1887L39.8866 10.1027Z",
    fill: "#1434CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.ea8297753c08f235619f02f2e3286ad8.svg";
export { ForwardRef as ReactComponent };